import { RouteInfo } from './vertical-menu.metadata';
import {ConstantsProvidersAdmin} from '../../services/constantsAdmin';
import {ConstantsProviders} from '../../services/constants';

//Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
  // {
  //   path: '/page', title: 'Dashboard', icon: 'ft-home', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'dash'
  // },
  {
    path: '/page/monitoreo', title: 'Monitoring', icon: 'fa fa-desktop', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], idpm: 'managment'
  },
  {
    path: '/page/cabbooking/p/g', title: 'Telephonist', icon: 'fa fa-headphones', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], idpm: 'telephonycab'
  },
  {
    path: '', title: 'Search', icon: 'fa fa-binoculars', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, idpm: 'mngfind',
    submenu: [
                { path: '/page/searchservice', title: 'History', icon: 'fa fa-history', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'findservice' },
                { path: '/page/searchscheduled', title: 'Schedule', icon: 'fa fa-clock-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'findschedule' },
    ]
  },
  {
    path: '', title: 'ControlFleet', icon: 'fa fa-tachometer', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, idpm: 'mngfleet',
    submenu: [
      { path: '/page/fleets', title: 'CtrlFleet', icon: 'fa fa-map', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'ctrlflota' },
      { path: '/page/chat', title: 'MessageFleet', icon: 'fa fa-wechat', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'msgflota' },
      { path: '/page/drivers', title: 'DriverAuth', icon: 'fa fa-drivers-license-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'driverlogin' },
    ]
  },
  {
    path: ConstantsProvidersAdmin.SERVERWSAPPADMIN, title: 'Administration', icon: 'fa fa-archive', class: '', isExternalLink: true, submenu: [], idpm: 'admingx'
  },
  {
    path: '', title: 'Configuración', icon: 'fa fa-cog', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, idpm: 'mngconfig',
    submenu: [
      ...(ConstantsProviders.ENABLE_FARE
        ? [{ path: '/page/fare', title: 'Tarifas', icon: 'fa fa-money', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], idpm: 'mngconfig' }]
        : []),
      ...(ConstantsProviders.ENABLE_ZONES
        ? [{ path: '/page/zones', title: 'Zonas', icon: 'fa fa-map-marker', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], idpm: 'ctrlzones' }]
        : []),
    ]
  },
  // {
  //   path: '/page/statistics', title: 'Estadísticas', icon: 'fa fa-line-chart', class: '', isExternalLink: false, submenu: [], idpm: 'statistics'
  // },
  // {
  //   path: '', title: 'Fare', icon: 'fa fa-money', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, idpm: 'mngfare',
  //   submenu: [
  //     { path: '/page/fare', title: 'FareConfirm', icon: 'fa fa-list', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'ctrlfare' },
  //     { path: '/page/holiday', title: 'Holiday', icon: 'fa fa-calendar', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'ctrolholiday' },
  //     { path: '/page/cupon', title: 'Cupon', icon: 'fa fa-ticket', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [],idpm: 'ctrlcupon' },
  //   ]
  // },
];
